import {
    ComponentType,
    Key,
    MouseEvent as ReactMouseEvent,
    useEffect,
    useLayoutEffect,
    useState
} from 'react'

import {
    Grid,
    GridCellProps,
    GridColumn,
    GridFooterCellProps,
    GridPageChangeEvent,
} from '@progress/kendo-react-grid'

import { Button, DropDownButton } from '@progress/kendo-react-buttons'
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import {
    TabStrip,
    TabStripSelectEventArguments,
    TabStripTab,
} from '@progress/kendo-react-layout'
import { format } from 'date-fns'
import { CSVLink } from 'react-csv'
import SessionStorageService from '../../services/SessionStorageService'
import styles from '../../styles/usodosolo/UsoDoSolo.module.scss'
import commonStyles from '../../styles/common/Common.module.scss'
import { ResultadoValorUsoDoSoloCommandGridCell } from './ResultadoValorUsoDoSoloCommandGridCell'

import { Dialog } from '@progress/kendo-react-dialogs'
import { b64toBlob, get, post, setEaRegistoAnalise } from '../../services/utils'
import { useValorUsoDoSoloStore } from '../../stores/valorUsoDoSolo'
import {
    AUTH_LOCALSTORAGE,
    GET_RELATORIO_DE_USO_DE_SOLO,
    PESQUISAR_ENTIDADEBYUSER,
    RELATORIO_VUS,
    URL_AJUDA_USOS_SOLO_VALOR,
    USO_DO_SOLO_MODULE_NAME,
    clearLayers
} from '../../utils/constants'
import DetalheValorUsoDoSolo from './DetalheValorUsoDoSolo'
import clsx from 'clsx'
import { useCommonStore } from '../../stores/common'
import MaximizeButton from '../common/MaximizeButton'
import useClearMap from '../../hooks/useClearMap'
import VisualizadorColunas from '../Generico/VisualizadorColunas '
import {
    elementoClickMais,
    itemRenderMais,
    mostraFloatingMenu_e_Mapa,
    ocultaFloatingMenu_e_Mapa,
    telaMobile
} from '../common/ItemRenderMais'
import { process } from '@progress/kendo-data-query'
import ReactGA from 'react-ga4'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import CustomGridCell from '../ocorrencia/CustomGridCell'
import html2canvas from 'html2canvas'

type IProps = {
    onCloseClick: (
        e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
    ) => void | undefined
}

type PageState = {
    skip: number
    take: number
}

const initialDataState: PageState = { skip: 0, take: 20 }

type ValorTituloUsoDoSolo = {
    id: number
    vus: string
    tipo: string
    valor: string
}
const keyPainelPrincipal: Key = 'valorUsoSoloColunasVisiveis'
const keyPainelDocumentos: Key = 'valorUsoSoloDocumentosColunasVisiveis'
export default function ResultadoValorUsoDoSolo({ onCloseClick }: IProps) {
    const [isMobile, setIsMobile] = useState(false)
    const [selected, setSelected] = useState<number>(0)
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false)
    const [valoresUsoDoSolo, setValoresUsoDoSolo] = useState<
        ValorTituloUsoDoSolo[]
    >([])
    const [page, setPage] = useState<PageState>(initialDataState)
    const [pageSizeValue, setPageSizeValue] = useState<
        number | string | undefined
    >()
    const [Analise_Resultado, setAnalise_Resultado] = useState<any>()

    const isCurrentViewMaximized = useCommonStore(
        (state) => state.isCurrentViewMaximized
    )

    const getRelatorioDeValorUsoDoSolo = async (data: any) =>
        await post<any, any>(GET_RELATORIO_DE_USO_DE_SOLO, data)

    const getEntidadeByUser = async (data: any) =>
        await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

    const relatorioVUS = async (data: any) =>
        await post<any, any>(`${RELATORIO_VUS}`, data)

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected)
    }
    const selectValorUsoDoSolo = useValorUsoDoSoloStore(
        (state) => state.selectValorUsoDoSoloResult
    )

    const handlePageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent
        const take = event.page.take

        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value)
        }

        setPage({
            ...event.page,
            take,
        })
    }

    const restoreView = useCommonStore((state) => state.restoreView)

    const [clearMap] = useClearMap()

    const clearSearchResults = () => {
        SessionStorageService.removeItem('resultadoValorUsoDoSoloPesquisa')
        setEaRegistoAnalise(undefined)
        if (sessionStorage.getItem('Modulo') == USO_DO_SOLO_MODULE_NAME) {
            clearMap(clearLayers['CLEAR_LAYERS_US_TITULO'])
        }
        postMessage({ type: 'resultadoUsoDoSoloPesquisaChange' }, '*')
    }

    useEffect(() => {
        let valoresUsoDoSoloStored = SessionStorageService.getItem(
            'resultadoValorUsoDoSoloPesquisa'
        )
        if (valoresUsoDoSoloStored) {
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)

            const formattedResults = valoresUsoDoSoloStored.resultadosPesquisa.map(
                (item: any) => ({
                    ...item,
                    ano: item.data_valor ? new Date(item.data_valor).getFullYear() : null,
                })
            )

            setValoresUsoDoSolo(formattedResults)

            const idsPoligono = valoresUsoDoSoloStored.resultadosPesquisa
                .filter((x: any) => x.tipo_geom_vus == 'Poligono')
                .map((v: { id?: number }) => v.id)
            const idsPonto = valoresUsoDoSoloStored.resultadosPesquisa
                .filter((x: any) => x.tipo_geom_vus == 'Ponto')
                .map((v: { id?: number }) => v.id)
            const iframe: any = document.getElementById('iframeGeoPortal')
            iframe.contentWindow?.postMessage(
                { type: 'SiarlUsVusPoligonoSearch', value: idsPoligono },
                '*'
            )
            iframe.contentWindow?.postMessage(
                { type: 'SiarlUsVusPontoSearch', value: idsPonto },
                '*'
            )
            setAnalise_Resultado(valoresUsoDoSoloStored)
        }
    }, [])

    const handleInfoClickById =
        (valorUsoDoSolo: Record<string, any>) => async () => {
            selectValorUsoDoSolo(valorUsoDoSolo)
            closeModal()
        }

    const getGpMessagePrefix = (item: Record<string, any>) => {
        return item.tipo_geom_vus.toLowerCase() == 'poligono'
            ? 'SiarlUsVusPoligono'
            : 'SiarlUsVusPonto'
    }

    const handleLocationClick = (usVus: Record<string, unknown>) => async () => {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const id = usVus.id
        const service = `${getGpMessagePrefix(usVus)}Center`

        iframe.contentWindow?.postMessage({ type: service, value: [id] }, '*')

        restoreView()
    }

    const handleRowMouseEnterById = (vus: Record<string, any>) => {
        console.log(`#${vus.id} - mostrar popover no mapa`)

        const id = vus.id ?? null

        if (id) {
            const iframe: any = document.getElementById('iframeGeoPortal')
            const service = `${getGpMessagePrefix(vus)}Highlight`

            iframe.contentWindow?.postMessage({ type: service, value: [id] }, '*')
        }
    }

    const handleRowMouseLeaveById = (vus: Record<string, unknown>) => {
        const id = vus.id ?? null

        if (id) {
            const iframe: any = document.getElementById('iframeGeoPortal')
            const service = `${getGpMessagePrefix(vus)}HighlightRemove`

            iframe.contentWindow?.postMessage({ type: service, value: [id] }, '*')
        }
    }

    const VusCustomCell = (props: GridCellProps) => (
        <CustomGridCell
            {...props}
            onMouseEnter={handleRowMouseEnterById}
            onMouseLeave={handleRowMouseLeaveById}
        />
    )

    const CommandCell = (props: GridCellProps) => (
        <ResultadoValorUsoDoSoloCommandGridCell
            {...props}
            onDetailsClick={handleInfoClickById}
            onMapCenter={handleLocationClick}
            onLocationMouseEnter={handleRowMouseEnterById}
            onLocationMouseLeave={handleRowMouseLeaveById}
        />
    )
    const closeModal = () => {
        setShowDetailModal(!showDetailModal)
    }

    const itemRender = (props: { item: any; itemIndex: number }) => {
        const isTitleItem = props.item.key === 'titulo'
        if (isTitleItem) {
            // Item de título personalizado
            return (
                <div className={styles.DropDownButtonTitulo}>
                    <span>{props.item.text}</span>
                </div>
            )
        } else {
            // Demais itens
            return (
                <div className={styles.DropDownButtonItem}>
                    <span>{props.item.text}</span>
                </div>
            )
        }
    }

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: '/ResultadoValorUsosDoSolo' })
    }, [])

    const optionsExportar = [
        {
            key: 'ExportarListaResultadosExcel',
            text: 'Excel',
        },
        {
            key: 'ExportarResultadosPesquisa',
            text: 'Relatório VUS',
        },
    ]

    let _export: any
    const exportExcel = () => {
        _export.save()
    }

    const onItemClickExportar = async (event: any) => {
        if (event.item.key == 'ExportarListaResultadosExcel') {
            exportExcel()
        }
        if (event.item.key == 'ExportarResultadosPesquisa') {
            onItemClickExportarResultadosPesquisa()
        }
    }

    const onItemClickDownloadPdf = async (event: any) => {
        postMessage({ type: 'showLoader' }, '*')
        let valoresUsoDoSoloStored = SessionStorageService.getItem(
            'resultadoValorUsoDoSoloPesquisa'
        )

        if (valoresUsoDoSoloStored) {
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)

            const documentoBase64 = await getRelatorioDeValorUsoDoSolo(
                valoresUsoDoSoloStored
            )

            if (documentoBase64) {
                const link = document.createElement('a')
                link.href = 'data:application/octet-stream;base64,' + documentoBase64
                link.download = 'ValorUsoDoSolo.pdf'
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                postMessage({ type: 'hideLoader' }, '*')
            }
        }
    }

    const faixasSalvaGuarda = [
        { id: 1, descricao: 'Faixa Nível 1 2050' },
        { id: 2, descricao: 'Faixa Nível 2 2100' },
        { id: 0, descricao: 'Nenhuma' },
    ]

    const { ano, faixaSalvaguarda } = Analise_Resultado?.pesquisa ?? {}

    const getTaxaAtualizacao = () => {
        let valoresUsoDoSoloStored = SessionStorageService.getItem(
            'resultadoValorUsoDoSoloPesquisa'
        )
        if (valoresUsoDoSoloStored) {
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)
            const v = valoresUsoDoSoloStored?.pesquisa.valor ?? 0
            const t: number = Number.parseFloat(v)
            return t
        }
        return 0
    }

    const getAnoReferencia = () => {
        let valoresUsoDoSoloStored = SessionStorageService.getItem(
            'resultadoValorUsoDoSoloPesquisa'
        )
        if (valoresUsoDoSoloStored) {
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)
            const v = valoresUsoDoSoloStored?.ano_referencia ?? 0

            if (v === 0) {
                return ''
            }

            return Number.parseFloat(v)
        }

        return ''
    }

    const ACell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ verticalAlign: 'bottom' }}>
                Índice: {getTaxaAtualizacao().toFixed(2)}
            </td>
        )
    }

    const BCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ verticalAlign: 'bottom' }}>
                Ano de análise: <span>{getAnoReferencia()}</span>
            </td>
        )
    }

    const CCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={props.style}>
                {/* Faixa 1: {faixaSalvaguarda} */}
            </td>
        )
    }

    const DCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={props.style}>
                {/* Faixa 2: {faixaSalvaguarda} */}
            </td>
        )
    }

    const getFormatedEurNumber = () => {
        let valoresUsoDoSoloStored = SessionStorageService.getItem(
            'resultadoValorUsoDoSoloPesquisa'
        )
        if (valoresUsoDoSoloStored) {
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)
            console.log({ valoresUsoDoSoloStored })
            const v = valoresUsoDoSoloStored?.valorTotal ?? 0
            return new Intl.NumberFormat('pt-PT', {
                style: 'currency',
                currency: 'EUR',
            }).format(v)
        }
    }

    const ECell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ verticalAlign: 'bottom' }}>
                Total: <div>{getFormatedEurNumber()}</div>
            </td>
        )
    }

    const [columsDocuments, setColumsDocuments] = useState<{
        columns: {
            field: string
            title: string
            width: number | string
            show: boolean
        }[]
    }>({
        columns: [
            { field: 'id', width: 70, title: 'ID', show: true },
            {
                field: 'filedoc_cod',
                width: 190,
                title: 'ID Documento Filedoc',
                show: true,
            },
            {
                field: 'data_publicacao',
                width: 150,
                title: 'Data publicação',
                show: true,
            },
            {
                field: 'tipoRecurso.designacao',
                width: 150,
                title: 'Tipo de recurso',
                show: true,
            },
            { field: 'titulo', width: 90, title: 'Título', show: true },
            { field: 'autores', width: 90, title: 'Autor', show: true },
            { field: 'entidade.nome', width: 90, title: 'Entidade', show: true },
            { field: 'id_estado', width: 'auto', title: 'Estado', show: true },
        ],
    })

    const centeredHeaderCell: React.FC = (props: any) => {
        return (
            <div
                style={
                    isMobile
                        ? {}
                        : {
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            color: '#001339',
                            cursor: 'pointer',
                        }
                }
            >
                {props.title}
            </div>
        )
    }

    const [colums, setColums] = useState<any>(() => {
        const storedValue = SessionStorageService.getItem('columnsValorUsosSolo')
        return (
            storedValue ?? {
                columns: [
                    {
                        field: 'id',
                        title: 'ID',
                        show: true,
                        width: 170,
                        footerCell: BCell,
                    },
                    {
                        field: 'usVus.descricao',
                        title: 'Vus',
                        show: true,
                        width: 190,
                        footerCell: CCell,
                    },
                    {
                        field: 'usTipoComponenteVus.descricao',
                        title: 'Tipo componente',
                        show: true,
                        width: 190,
                        footerCell: DCell,
                    },
                    {
                        field: 'ano',
                        title: 'Ano',
                        show: true,
                        width: 190,
                        footerCell: ECell,
                    },
                    {
                        field: 'valor',
                        title: 'Valor',
                        show: true,
                        width: 190,
                        headerCell: centeredHeaderCell,
                        className: styles.eaGridColumnRightContent,
                        //footerCell: ECell,
                    },
                ],
            }
        )
    })

    useEffect(() => {
        SessionStorageService.setItem('columnsValorUsosSolo', colums)
    }, [colums])

    const onItemClickExportarResultadosPesquisa = async () => {
        try {
            let mapImage = ''

            if (!window.location.href.includes('localhost')) {
                const mapIframe = document.querySelector(
                    '#iframeGeoPortal'
                ) as HTMLIFrameElement

                const mapIframeInnerContent =
                    mapIframe.contentWindow?.document.querySelector(
                        'div.ol-viewport'
                    ) as HTMLElement

                const mapBussula = mapIframe.contentWindow?.document.querySelector(
                    'button.fixedNorthArrowButton'
                ) as HTMLElement

                mapIframeInnerContent.appendChild(mapBussula)

                const generatedImage = await html2canvas(mapIframeInnerContent)
                mapImage = generatedImage.toDataURL()
            }

            const formatNumber = (value: any) => {
                return new Intl.NumberFormat('pt-PT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value)
            }

            let valoresUsoDoSoloStored = SessionStorageService.getItem(
                'resultadoValorUsoDoSoloPesquisa'
            )
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)
            const valorTotal = formatNumber(valoresUsoDoSoloStored?.valorTotal)
            const taxaAtualizacao = formatNumber(
                valoresUsoDoSoloStored?.taxa_atualizacao
            )
            const userName = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')
                ?.user?.name
            const ResultEntidade = await getEntidadeByUser(
                JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')?.user?.id
            )
            const ano_indice = valoresUsoDoSoloStored?.ano_referencia

            const ATUALIZACAO_PRECOS_ATUAL = 0
            const ATUALIZACAO_PRECOS_MANUAL = 1
            const ATUALIZACAO_PRECOS_ANO_REFERENCIA = 3
            const ATUALIZACAO_PRECOS_SEM_ATUALIZACAO = 5

            let atualizacaoPrecos

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_ATUAL
            ) {
                atualizacaoPrecos = 'Preços atuais (IPC)'
            }

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_MANUAL
            ) {
                atualizacaoPrecos =
                    'Preços por índice manual\n' +
                    'Índice ' +
                    valoresUsoDoSoloStored?.pesquisa?.valor
            }

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_ANO_REFERENCIA
            ) {
                atualizacaoPrecos =
                    'Preços por ano referência (IPC)\n' +
                    'Ano ' +
                    valoresUsoDoSoloStored?.pesquisa?.anoSelecionado
            }

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_SEM_ATUALIZACAO
            ) {
                atualizacaoPrecos = 'Sem atualização de preços'
            }

            postMessage({ type: 'showLoader' }, '*')

            const agrupados: any = {}

            for (const resultado of valoresUsoDoSoloStored.resultadosPesquisa) {
                const chaveAgrupamento = `${resultado?.usVus?.descricao}-${resultado?.usTipoComponenteVus?.usVus?.usTipoVus?.descricao}-${resultado?.usTipoComponenteVus?.descricao}`

                if (!agrupados[chaveAgrupamento]) {
                    agrupados[chaveAgrupamento] = {
                        id: resultado.id,
                        img_mapa: mapImage,
                        dados: {
                            // pesquisa
                            Data: new Date().toLocaleDateString() ?? '',
                            Tecnico: userName ?? '',
                            Entidade: ResultEntidade?.nome ?? '',

                            // parametros
                            'Atualizacao precos': atualizacaoPrecos ?? '',

                            // tabela
                            Vus: resultado?.usVus?.descricao ?? '',
                            'Tipo VUS':
                                resultado?.usTipoComponenteVus?.usVus?.usTipoVus?.descricao ??
                                '',
                            'Tipo componente':
                                resultado?.usTipoComponenteVus?.descricao ?? '',
                            Valor: resultado?.valor ?? 0,
                            Total: valorTotal ?? '',
                            'Ano por registo': resultado.data_valor
                                ? new Date(resultado.data_valor).getFullYear()
                                : null,

                            // variáveis de cálculo
                            'Fator atualizacao': taxaAtualizacao ?? '',
                            Ano: ano_indice ?? '',
                        },
                    }
                } else {
                    agrupados[chaveAgrupamento].dados['Valor'] += resultado?.valor ?? 0
                }
            }

            for (const chave in agrupados) {
                agrupados[chave].dados['Valor'] = formatNumber(
                    agrupados[chave].dados['Valor']
                )
            }

            const relatorios = Object.values(agrupados)

            const PdfBase64 = await relatorioVUS(relatorios)
            if (PdfBase64) {
                const link = document.createElement('a')
                link.href = 'data:application/octet-stream;base64,' + PdfBase64
                link.download = 'reporte_vus.pdf'
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                postMessage({ type: 'hideLoader' }, '*')
            }
        } catch (error) {
            console.log(error)
            postMessage(
                {
                    type: 'errorMsg',
                    value: { left: '50%', message: 'Verifique os campos obrigatórios.' },
                },
                '*'
            )
        } finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const onItemClickImprimirResultadosPesquisa = async () => {
        try {
            let mapImage = ''

            if (!window.location.href.includes('localhost')) {
                const mapIframe = document.querySelector(
                    '#iframeGeoPortal'
                ) as HTMLIFrameElement

                const mapIframeInnerContent =
                    mapIframe.contentWindow?.document.querySelector(
                        'div.ol-viewport'
                    ) as HTMLElement

                const mapBussula = mapIframe.contentWindow?.document.querySelector(
                    'button.fixedNorthArrowButton'
                ) as HTMLElement

                mapIframeInnerContent.appendChild(mapBussula)

                const generatedImage = await html2canvas(mapIframeInnerContent)
                mapImage = generatedImage.toDataURL()
            }

            const formatNumber = (value: any) => {
                return new Intl.NumberFormat('pt-PT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value)
            }

            let valoresUsoDoSoloStored = SessionStorageService.getItem(
                'resultadoValorUsoDoSoloPesquisa'
            )
            valoresUsoDoSoloStored = JSON.parse(valoresUsoDoSoloStored)
            const valorTotal = formatNumber(valoresUsoDoSoloStored?.valorTotal)
            const taxaAtualizacao = formatNumber(
                valoresUsoDoSoloStored?.taxa_atualizacao
            )
            const userName = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')
                ?.user?.name
            const ResultEntidade = await getEntidadeByUser(
                JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')?.user?.id
            )
            const ano_indice = valoresUsoDoSoloStored?.ano_referencia
            const ATUALIZACAO_PRECOS_ATUAL = 0
            const ATUALIZACAO_PRECOS_MANUAL = 1
            const ATUALIZACAO_PRECOS_ANO_REFERENCIA = 3
            const ATUALIZACAO_PRECOS_SEM_ATUALIZACAO = 5

            let atualizacaoPrecos

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_ATUAL
            ) {
                atualizacaoPrecos = 'Preços atuais (IPC)'
            }

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_MANUAL
            ) {
                atualizacaoPrecos =
                    'Preços por índice manual\n' +
                    'Índice ' +
                    valoresUsoDoSoloStored?.pesquisa?.valor
            }

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_ANO_REFERENCIA
            ) {
                atualizacaoPrecos =
                    'Preços por ano referência (IPC)\n' +
                    'Ano ' +
                    valoresUsoDoSoloStored?.pesquisa?.anoSelecionado
            }

            if (
                valoresUsoDoSoloStored?.pesquisa?.atualizacaoDePreco ==
                ATUALIZACAO_PRECOS_SEM_ATUALIZACAO
            ) {
                atualizacaoPrecos = 'Sem atualização de preços'
            }

            postMessage({ type: 'showLoader' }, '*')

            const agrupados: any = {}

            for (const resultado of valoresUsoDoSoloStored.resultadosPesquisa) {
                const chaveAgrupamento = `${resultado?.usVus?.descricao}-${resultado?.usTipoComponenteVus?.usVus?.usTipoVus?.descricao}-${resultado?.usTipoComponenteVus?.descricao}`

                if (!agrupados[chaveAgrupamento]) {
                    agrupados[chaveAgrupamento] = {
                        id: resultado.id,
                        img_mapa: mapImage,
                        dados: {
                            // pesquisa
                            Data: new Date().toLocaleDateString() ?? '',
                            Tecnico: userName ?? '',
                            Entidade: ResultEntidade?.nome ?? '',

                            // parametros
                            'Atualizacao precos': atualizacaoPrecos ?? '',

                            // tabela
                            Vus: resultado?.usVus?.descricao ?? '',
                            'Tipo VUS':
                                resultado?.usTipoComponenteVus?.usVus?.usTipoVus?.descricao ??
                                '',
                            'Tipo componente':
                                resultado?.usTipoComponenteVus?.descricao ?? '',
                            Valor: resultado?.valor ?? 0,
                            Total: valorTotal ?? '',
                            'Ano por registo': resultado.data_valor
                                ? new Date(resultado.data_valor).getFullYear()
                                : null,

                            // variáveis de cálculo
                            'Fator atualizacao': taxaAtualizacao ?? '',
                            Ano: ano_indice ?? '',
                        },
                    }
                } else {
                    agrupados[chaveAgrupamento].dados['Valor'] += resultado?.valor ?? 0
                }
            }

            for (const chave in agrupados) {
                agrupados[chave].dados['Valor'] = formatNumber(
                    agrupados[chave].dados['Valor']
                )
            }

            const relatorios = Object.values(agrupados)

            const PdfBase64 = await relatorioVUS(relatorios)
            if (PdfBase64) {
                const blob = b64toBlob(PdfBase64, 'application/pdf')
                const blobUrl = URL.createObjectURL(blob)
                window.open(blobUrl, '_blank')
            }
        } catch (error) {
            console.log(error)
            postMessage(
                {
                    type: 'errorMsg',
                    value: { left: '50%', message: 'Verifique os campos obrigatórios.' },
                },
                '*'
            )
        } finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const combinedData = valoresUsoDoSolo
        ?.slice(page.skip, page.take + page.skip)
        .map((vus: any) => ({
            ...vus,
            valor: new Intl.NumberFormat('pt-PT', {
                style: 'currency',
                currency: 'EUR',
            }).format(vus.valor),
        }))

    useLayoutEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= telaMobile) {
                setIsMobile(true)
                ocultaFloatingMenu_e_Mapa()
            } else {
                setIsMobile(false)
                mostraFloatingMenu_e_Mapa()
            }
        }

        window.addEventListener('resize', handleResize)

        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const onItemClickMais = (event: any) => {
        elementoClickMais(event)

        onItemClickExportar(event)

        onItemClickDownloadPdf(event)
    }

    const optionsMais = [
        {
            key: 'titulo',
            text: 'Imprimir',
        },
        {
            key: 'imprimirFicha',
            text: 'Resultados',
            className: 'icon-siarl icon-imprimir btnIconRegistar',
        },
        {
            key: 'titulo',
            text: 'Exportar',
        },
        ...optionsExportar.map((option) => ({
            ...option,
            className: 'icon-siarl icon-exportar btnIconRegistar',
        })),
    ]
    const [dataState, setDataState] = useState({
        skip: 0,
        take: 20,
        sort: [],
        group: [],
    })
    const dataStateChange = (event: any) => {
        setDataResult(process(valoresUsoDoSolo, event.dataState))
        setDataState(event.dataState)
    }
    const [dataResult, setDataResult] = useState(
        process(valoresUsoDoSolo, dataState)
    )

    const openAjuda = () => {
        window.open(URL_AJUDA_USOS_SOLO_VALOR, '_blank')
    }

    return (
        <>
            <div
                className={clsx(
                    styles.base,
                    isCurrentViewMaximized && commonStyles.maximizedBaseForm
                )}
            >
                <div className={styles.header}>
                    <div>
                        <div className={styles.nomeDoModulo}>Usos de solo</div>
                        <div className={styles.tituloDaPagina}>Resultados de pesquisa</div>
                    </div>

                    <div>
                        {!isMobile && (
                            <VisualizadorColunas
                                columns={selected === 0 ? colums : columsDocuments}
                                setColumns={selected === 0 ? setColums : setColumsDocuments}
                                styles={styles.btnEditar2}
                            />
                        )}
                        <CSVLink
                            title="Imprimir resultados"
                            id="print-results"
                            data={[]}
                            filename={`siarl-valorUsoDoSolo-${format(
                                new Date(),
                                'ddMMyyyHHmm'
                            )}`}
                            hidden
                        ></CSVLink>

                        <button
                            className={styles.btnEditar2}
                            onClick={onItemClickImprimirResultadosPesquisa}
                            title="Imprimir"
                        >
                            <span className="icon-siarl icon-imprimir"></span>
                        </button>

                        {!isMobile && (
                            <DropDownButton
                                items={optionsExportar}
                                className={styles.btnImprimir}
                                style={{ marginTop: '-4px' }}
                                iconClass="icon-siarl icon-exportar"
                                onItemClick={onItemClickExportar}
                                fillMode={'flat'}
                                itemRender={itemRender}
                                title="Exportar"
                            ></DropDownButton>
                        )}

                        {isMobile && (
                            <DropDownButton
                                items={optionsMais}
                                className={styles.btnMais}
                                iconClass="icon-siarl icon-mais"
                                onItemClick={onItemClickMais}
                                fillMode={'flat'}
                                itemRender={itemRenderMais}
                                title="Mais Opções"
                            />
                        )}

                        <button
                            onClick={openAjuda}
                            className={styles.btnInfo}
                            title="Obter Ajuda"
                        >
                            <span className="icon-siarl icon-ajuda"></span>
                        </button>
                        <button
                            onClick={onCloseClick}
                            className={styles.btnFechar}
                            title="Minimizar"
                        >
                            <span className="icon-siarl icon-minimizar"></span>
                        </button>

                        {!isMobile && <MaximizeButton className={styles.btnMaximizar} />}
                    </div>
                </div>

                <TabStrip
                    selected={selected}
                    onSelect={handleSelect}
                    scrollable={isMobile}
                >
                    <TabStripTab title="Valores de uso de solo" key={'titulos'}>
                        <ExcelExport
                            fileName="Resultado_ValoresUsoSolo"
                            data={valoresUsoDoSolo}
                            ref={(exporter: any) => {
                                _export = exporter
                            }}
                        >
                            <Grid
                                sortable={true}
                                onDataStateChange={dataStateChange}
                                data={
                                    dataResult.data.length > 0
                                        ? dataResult.data.slice(page.skip, page.take + page.skip)
                                            .map((vus: any) => ({
                                                ...vus,
                                                valor: new Intl.NumberFormat('pt-PT', {
                                                    style: 'currency',
                                                    currency: 'EUR',
                                                }).format(vus.valor),
                                            }))
                                        : valoresUsoDoSolo
                                            ?.slice(page.skip, page.take + page.skip)
                                            .map((vus: any) => ({
                                                ...vus,
                                                valor: new Intl.NumberFormat('pt-PT', {
                                                    style: 'currency',
                                                    currency: 'EUR',
                                                }).format(vus.valor),
                                            }))
                                }
                                {...dataState}
                                pageable={{
                                    buttonCount: 5,
                                    info: true,
                                    type: 'numeric',
                                    pageSizes: true,
                                    previousNext: true,
                                }}
                                total={valoresUsoDoSolo.length}
                                cells={{ data: VusCustomCell }}
                                className={styles.form}
                            >
                                <GridColumn cell={CommandCell} width={156} footerCell={ACell} />
                                {colums?.columns?.map(
                                    (
                                        column: {
                                            show: any
                                            field: string | undefined
                                            width: string | number | undefined
                                            title: string | undefined
                                            footerCell: ComponentType<GridFooterCellProps> | undefined
                                            headerCell?: any | undefined
                                            className?: string | undefined
                                        },
                                        i: Key | null | undefined
                                    ) => {
                                        return (
                                            column.show && (
                                                <GridColumn
                                                    key={i}
                                                    field={column.field}
                                                    width={column.width}
                                                    title={column.title}
                                                    headerCell={column.headerCell}
                                                    className={column.className}
                                                    footerCell={column.footerCell}
                                                />
                                            )
                                        )
                                    }
                                )}
                                {/* <GridColumn field="id" width={170} title="ID" footerCell={BCell} />
              <GridColumn field="usVus.descricao" width={190} title="Vus" footerCell={CCell} />
              <GridColumn field="usVus.usTipoVus.descricao" width={190} title="Tipo" footerCell={DCell} />
              <GridColumn field="valor" width={'auto'} title="valor" footerCell={ECell} /> */}
                            </Grid>
                        </ExcelExport>
                    </TabStripTab>
                </TabStrip>

                <div
                    className={clsx(
                        styles.footer,
                        styles.justify_one_child,
                        isCurrentViewMaximized && commonStyles.maximizedFooter
                    )}
                >
                    <Button
                        className={styles.btnPesquisar}
                        onClick={clearSearchResults}
                        title="Nova Análise"
                    >
                        <span className="icon-siarl icon-pesquisar btnIconPesquisar"></span>
                        <span className={styles.rotulo}> &nbsp; Nova Análise</span>
                    </Button>
                </div>
            </div>
            {showDetailModal ? (
                <Dialog
                    className="ModalDocumentos"
                    onClose={closeModal}
                    title={'Detalhes'}
                    style={{ zIndex: 999 }}
                >
                    <DetalheValorUsoDoSolo />
                </Dialog>
            ) : (
                <></>
            )}
        </>
    )
}
